import React from 'react';
import logo from './../img/cocktailSmall.png';

function CocktailLogo() {
  
  return <img src={logo} alt="Logo" />;
}
export default CocktailLogo;